import {Injectable} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError, from } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import { ToastController, AlertController } from '@ionic/angular';
import { LoadingController, Platform, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';


const TOKEN_KEY = 'auth-token';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    //protected url   = 'http://intranet.jogosa.es:8082';
    protected url   = 'https://work-time-control.jogosa.es';

    protected debug = false;

    constructor(
        private alertController: AlertController, 
        private toastController: ToastController,
        private storage: Storage
    ) {
        
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // YOU CAN ALSO DO THIS
        // const token = this.authenticationService.getToke()

        return from(this.storage.get(TOKEN_KEY))
            .pipe(
                switchMap(token => {
                    if (token) {
                        request = request.clone({ headers: request.headers.set('Authorization', 'JWT ' + token) });
                    }

                    if (!request.headers.has('Content-Type')) {
                        request = request.clone({ 
                            headers: request.headers.set('Content-Type', 'application/json')
                        });
                    }

                    //if (this.debug) {
                        request = request.clone({ url: this.url + request.url/* + '?XDEBUG_SESSION_START=1'*/});
                    //}

                    return next.handle(request).pipe(
                        map((event: HttpEvent<any>) => {
                            if (event instanceof HttpResponse) {
                                // do nothing for now
                            }
                            return event;
                        }),
                        catchError((error: HttpErrorResponse) => {
                            const status =  error.status;
                            const reason = error && error.error.reason ? error.error.reason : error.message;

                            let toast = this.toastController.create({
                                message: reason + "(" + String(status) + ")",
                                duration: 300,
                                position: 'bottom',
                            }).then((toast)=>{
                                toast.present();
                            });

                            return throwError(error);
                        })
                    );
                })
            );
    }

    async presentAlert(status, reason) {
        const alert = await this.alertController.create({
            header: status + ' Error',
            subHeader: 'Subtitle',
            message: reason,
            buttons: ['OK']
        });

        await alert.present();
    }
}
